import React from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import VehicleInspectionReservationConfirmBottomSheet from '@di-shared/features/public-service/vehicle-inspection/reservation/VehicleInspectionReservationConfirmBottomSheet';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 500;

export default function VehicleInspectionReservationConfirmBottomSheetPage() {
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <VehicleInspectionReservationConfirmBottomSheet />
    </BottomSheetWebViewWrapper>
  );
}
